module.exports = __webpack_public_path__ + "static/img/gift.00e9f01b.png";